import React, { useState } from 'react';
import {
  Box,
  Button,
  Modal,
  TextField,
  FormControlLabel,
  Switch,
  IconButton,
  Checkbox,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Typography
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { tokens } from "../../theme";
import DeleteIcon from '@mui/icons-material/Delete';

const Collection2 = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const colors = tokens(theme.palette.mode);

  const [rows, setRows] = useState([
    { id: 1, siNo: 1, lov: '', active: false, startDate: '', endDate: '' },
  ]);

  const [openModal, setOpenModal] = useState(false);

  const handleAddRow = () => {
    setRows([
      ...rows,
      { id: rows.length + 1, siNo: rows.length + 1, lov: '', active: false, startDate: '', endDate: '' },
    ]);
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleDeleteRow = (id) => {
    const updatedRows = rows.filter(row => row.id !== id);
    setRows(updatedRows);
  };

  const handleSave = () => {
    // Save logic can go here
    setOpenModal(false);
  };

  const validateRows = () => {
    // Check if all rows have valid data
    return rows.every(row => row.lov && row.startDate && row.endDate);
  };

  const columns = [
    { field: 'siNo', headerName: 'Sl.No', flex: 0.5 },
    {
      field: 'collectionRequestNo',
      headerName: 'Collection Request Number',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.collectionRequestNo}
          onChange={(e) => handleRowChange(params.row.id - 1, 'collectionRequestNo', e.target.value)}
          fullWidth
        />
      ),
    },
    {
      field: 'invoiceno',
      headerName: 'Invoice No',
      flex: 1,
      renderCell: (params) => (
        <Select
          value={params.row.invoiceno}
          onChange={(e) => handleRowChange(params.row.id - 1, 'invoiceno', e.target.value)}
          fullWidth
        >
          <MenuItem value="INV001">INV001</MenuItem>
          <MenuItem value="INV002">INV002</MenuItem>
          <MenuItem value="INV003">INV003</MenuItem>
        </Select>
      ),
    },
    {
      field: 'receivedAmount',
      headerName: 'Received Amount',
      flex: 1,
      renderCell: (params) => (
        <TextField
          type="number"
          value={params.row.receivedAmount}
          onChange={(e) => handleRowChange(params.row.id - 1, 'receivedAmount', e.target.value)}
          fullWidth
        />
      ),
    },
    {
      field: 'receiptMethodId',
      headerName: 'Receipt Method Id',
      flex: 1,
      renderCell: (params) => (
        <Select
          value={params.row.receiptMethodId}
          onChange={(e) => handleRowChange(params.row.id - 1, 'receiptMethodId', e.target.value)}
          fullWidth
        >
          <MenuItem value="Cash">Cash</MenuItem>
          <MenuItem value="Card">Card</MenuItem>
          <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
        </Select>
      ),
    },
    {
      field: 'transactionDate',
      headerName: 'Transaction Date',
      flex: 1,
      renderCell: (params) => (
        <TextField
          type="date"
          value={params.row.transactionDate}
          onChange={(e) => handleRowChange(params.row.id - 1, 'transactionDate', e.target.value)}
          fullWidth
        />
      ),
    },
    {
      field: 'receivedBy',
      headerName: 'Received By',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.receivedBy}
          onChange={(e) => handleRowChange(params.row.id - 1, 'receivedBy', e.target.value)}
          fullWidth
        />
      ),
    },
    {
      field: 'adjustmentId',
      headerName: 'Adjustment ID',
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2">
          {params.row.adjustmentId || '-'}
        </Typography>
      ),
    },
    {
      field: 'disputeId',
      headerName: 'Dispute ID',
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2">
          {params.row.disputeId || '-'}
        </Typography>
      ),
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.remarks}
          onChange={(e) => handleRowChange(params.row.id - 1, 'remarks', e.target.value)}
          fullWidth
        />
      ),
    },
    {
      field: 'transactionRef',
      headerName: 'Transaction Reference',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.transactionRef}
          onChange={(e) => handleRowChange(params.row.id - 1, 'transactionRef', e.target.value)}
          fullWidth
        />
      ),
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 0.5,
      renderCell: (params) => (
        <IconButton
          color="secondary"
          onClick={() => handleDeleteRow(params.row.id)}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <Box m="20px">
      <h2>Collection Transaction</h2>

      <Box display="flex" justifyContent="space-between" mb="20px">
        <Button
          color="primary"
          variant="contained"
          onClick={handleAddRow}
          // disabled={!validateRows()}  // Disable the button if any row is invalid
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.primary[400],
            fontSize: "14px",
            fontWeight: "bold",
            margin: "10px",
          }}
        >
          + Add Row
        </Button>
        <Button
          color="secondary"
          variant="contained"
          onClick={handleSave}
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.primary[400],
            fontSize: "14px",
            fontWeight: "bold",
            margin: "10px",
          }}
        >
          Save
        </Button>
      </Box>

      <Box
        height="78vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid grey",
            whiteSpace: "normal",
            wordWrap: "break-word",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
            fontSize: "14px",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
            height: "5vh",
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          checkboxSelection
          disableSelectionOnClick
        />
      </Box>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <IconButton
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
            onClick={() => setOpenModal(false)}
          >
            <CloseIcon />
          </IconButton>
          <h2>Manage Profile</h2>
          <FormControl fullWidth margin="normal">
            <InputLabel>Item Category</InputLabel>
            <Select
              value={""}
              onChange={() => { }}
              label="Item Category"
            >
              <MenuItem value="Category 1">Category 1</MenuItem>
              <MenuItem value="Category 2">Category 2</MenuItem>
              <MenuItem value="Category 3">Category 3</MenuItem>
            </Select>
          </FormControl>

          <Box display="flex" justifyContent="center" sx={{ mt: 2 }}>
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Collection2;